// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import global from './api/global.js';
import MintUI from 'mint-ui'
import store from './vuex/store'
import 'mint-ui/lib/style.css'
import VueCookies from 'vue-cookies'

Vue.prototype.$axios = axios
axios.defaults.withCredentials = true;
Vue.prototype.GLOBAL = global;

Vue.config.productionTip = false

Vue.use(VueCookies)
Vue.use(MintUI)
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js